import React from "react"

export default function Home() {
    return (
        <div>
            <h1>Welcome to my website</h1>
        </div>
    )
}
